import { Component, Inject, ViewChild, SecurityContext } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment';
import { T4Image, RentalContractInfo, ServiceGuyInfo, RequestUpdate, User } from 't4core';
import { DialogBase, T4ServiceService, LocationInfo, ServiceLocationInfo } from 't4core';
import { RequestDetails, ServiceRequestStatus } from 't4core';
import { IssueNoteDialog } from '../issueNoteDialog/issueNoteDialog';
import { MatTabGroup } from '@angular/material/tabs';
import { ImageDialog } from '../../../../t4common/dialogs/ImageDialog/ImageDialog';
import { TerminationDialog } from '../../../TurboOrder/dialogs/TerminationDialog/TerminationDialog';
import { AddCostsDialog } from '../../../TurboOrder/dialogs/AddCostsDialog/AddCostsDialog';
import { InsuranceImageInfoDialogComponent } from '../../../../t4common/dialogs/insurance-image-info-dialog/insurance-image-info-dialog.component';
import { UploadImagesDialog } from '../../../../t4common/dialogs/uploadImagesDialog/uploadImagesDialog';
import { T4File, RequestFeedbackType, T4RentalLocationService, DisableObjectResult } from '../../../../../projects/t4core/src/public-api';
import { OnInit } from '@angular/core';
import { SmsDialog } from '../../../../t4common';
import { empty } from 'rxjs';
import { request } from 'http';
import { DomSanitizer, SafeResourceUrl, SafeStyle } from '@angular/platform-browser';
import { PdfServiceDialog } from '../pdfServiceDialog/pdfServiceDialog';
import { ServiceMessageDialogDialog } from '../serviceMessageDialog/serviceMessageDialog';
import { ContactInfoDialog } from '../contactInfoDialog/contactInfoDialog';



@Component({
  selector: 'owa-serviceDialog',
  templateUrl: 'serviceDialog.html',
})
export class T4_ServiceDialog extends DialogBase implements OnInit{
  @ViewChild('tabControl', { static: false }) tabControl: MatTabGroup;

    private requestId: string;
    public request: RequestDetails = new RequestDetails();
    public servicePartner: ServiceLocationInfo = new ServiceLocationInfo();

    public availableTags = ['Saknas', 'Körförbud', 'Besiktning', 'Nyproduktion', 'Stöld (under uthyrning)', 'Stöld (från station)', 'Försäkringsskada (under uthyrning)', 'Försäkringsskada (på station)'];

    public ctrlTags = new FormControl();
    public images: T4Image[] = [];
    public isStolen: boolean = false;

    public spareParts: number;
    public sparePartsDiscount: number;
    public transport: number;
    public labor: number;
    public deductible: number;

    public serviceGuy: ServiceGuyInfo;

    public files: T4File[] = [];
    public noOfFiles: number = 0;
    public imageUploaded: boolean = false;
    public fileUploaded: boolean = false; 

    public serviceParterList: LocationInfo[];
    public selectedServicePartner: LocationInfo;

    public isLoading: boolean = true;
    public isDocumentLoading: boolean = false;

    public owner: string;
    public selectOwner: string[];
    public header;
    public documentUri: SafeResourceUrl;

    public backoffice: boolean = this.Settings.isInAny(['BackOffice'], true);

  public hasServicePartner() : boolean {
    return (this.request.IsOneWay && this.request.ObjectLocation.ServiceLocation != null) || (!this.request.IsOneWay && this.request.ObjectLocation.LocalServiceLocation != null);
  }

  constructor(
    public dialogRef: MatDialogRef<T4_ServiceDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private svcService: T4ServiceService,
    private sanitizer: DomSanitizer,
  ) {
      super("ServiceDialog");
    this.request.IsInsurance = true;

    this.requestId = data.requestId;
    
  }

    public async ngOnInit() {
      this.loadRequest();
      this.getOwners();
      
    
  }

  public async loadServicePartners() {

    var token = this.beginLoad('Turbo.OneWayAdmin.ServiceDialog.msgLoadingServicePartners', 'Loading service partners', null);
      
    try {
      this.serviceParterList = await this.Api.get<LocationInfo[]>('/Service/GetServicePartners', { lat: this.request.RentalObject.RentalLocation.Latitude, lng: this.request.RentalObject.RentalLocation.Longitude });
       
      if (this.servicePartner) {
        var newObj = this.serviceParterList.find(x => x.Id == this.servicePartner.Id);
        if (newObj) this.selectedServicePartner = newObj;
      }
    }
    catch (e) {
      console.log(e);
    }

    this.endLoad(token);
  }

  private async loadRequest() {
    var token = this.beginLoad('Turbo.OneWayAdmin.ServiceDialog.msgLoadingRequest', 'Loading request', null);
    this.request = await this.Api.get<RequestDetails>('/Service/GetRequest', { id: this.requestId });
    this.documentUri = this.sanitizer.bypassSecurityTrustResourceUrl(this.request.ServiceDocument); 

    this.serviceGuy = await this.Api.get<any>('/Service/GetLocationServiceGuy', { locationId: this.request.RentalObject.RentalLocation.Id })
    
    if (this.request.ServiceLocation) {
      this.servicePartner = this.request.ServiceLocation;
    }
    else {
      if (this.request.IsOneWay && this.request.ObjectLocation.ServiceLocation) {
        this.servicePartner = this.request.ObjectLocation.ServiceLocation;
      } else if (!this.request.IsOneWay && this.request.ObjectLocation.LocalServiceLocation) {
        this.servicePartner = this.request.ObjectLocation.LocalServiceLocation;
      }
    }

    this.loadServicePartners();

      if (this.request.IsInsurance) {
        this.availableTags = ['Saknas', 'Körförbud', 'Besiktning', 'Nyproduktion', 'Stöld (under uthyrning)', 'Stöld (från station)', 'Försäkringsskada (under uthyrning)', 'Försäkringsskada (på station)'];
      }
      else {
        this.availableTags = ['Saknas', 'Körförbud', 'Besiktning', 'Nyproduktion'];
      }

      this.ctrlTags.setValue(this.request.Tags);

      this.isStolen = this.request.Tags.indexOf('Stöld (under uthyrning)') >= 0 || this.request.Tags.indexOf('Stöld (från station)') >= 0;

      this.owner = this.request?.Owner;
    this.endLoad(token);
    this.isLoading = false;

      // Load files discreetly
    if (this.request.ImageIds) {
      try {
        this.files = await this.Api.get<any[]>("Service/GetFiles", { requestId: this.request.Id });
        if (this.files.length == 0)
           this.files = await this.Api.get<any[]>("Service/GetFiles", { requestId: this.request.ImageIds });
      } catch (ex) {

        this.files = [];
      }
    } else {
      this.files = [];
    }

      if (this.files.find(x => x.Filename.startsWith('doc_'))) { this.fileUploaded = true; }
      else { this.fileUploaded = false; }

      if (this.files.find(x => x.Filename.startsWith('img_'))) { this.imageUploaded = true; }
      else { this.imageUploaded = false; }

      this.noOfFiles = this.files.length - 1;   
  }

  public async invoice() {
    var ret = await this.UI.openDialog<any>("T4.Common.AmountDialog", { data: { message: "Självrisk avseende " + this.request.RentalObject.Title, amount: 5000, showComment: true } });
    if (ret && ret.Amount != 0) {
        await this.svcService.CreateInvoice(this.requestId, ret.amount, ret.message);
        this.request.SelfRisk = ret.Amount;
      this.UI.snackBar("Invoice created!");

      this.loadRequest();
    }
  }

  public async getOwners() {
    var token = this.beginLoad('Turbo.OneWayAdmin.ServiceDialog.msgLoadingOwner', 'Loading Owners', null);
      this.selectOwner = await this.Api.get<string[]>("RentalObjectService/GetSelectOwners")
    this.endLoad(token);
  }

  public async changeOwner(newOwner) {
    var token = this.beginLoad('Turbo.OneWayAdmin.ServiceDialog.msgChangingOwner', 'Changing Owner', null);
      await this.Api.get<boolean>("RentalObjectService/ChangeOwner", { newOwner: newOwner, requestNo: this.request.RequestNo });
    this.endLoad(token);
  }



  public async disable() {
   
    var token = this.beginLoad('Turbo.OneWayAdmin.ServiceDialog.msgLoadingDisable', 'Loading disable', null);
    var result = await this.Api.get<DisableObjectResult>("RentalObjectService/Disable", { objectId: this.request.RentalObjectId });
    await this.loadRequest();
    this.endLoad(token);

    return result.IsSuccessful;
  }

  public async enable() {
    var token = this.beginLoad('Turbo.OneWayAdmin.ServiceDialog.msgLoadingEnable', 'Loading enable', null);

    var result = await this.Api.get<boolean>("RentalObjectService/Enable", { objectId: this.request.RentalObjectId });
    await this.loadRequest();

    this.endLoad(token);

    return result;
  }

  public async sendMailDialog() {
    var content = await this.UI.prompt("Turbo.ServiceDialog.promptSendEmailHeadline", "Send a message", "Turbo.ServiceDialog.promptSendEmailServiceGuyMsg", "Write a message below explaining the issues with this case. The message will be sent to the service guy.", this.serviceGuy.Email, this.serviceGuy.Email);
    if (content) {
      this.Api.post("Messaging/SendMailServiceGuy", null, { serviceGuyId: this.serviceGuy.Id, message: content, requestId: this.request.RequestNo }).then(x => {
        this.UI.alert("Turbo.ServiceDialog.sendEmailSuccess", "Mail sent", "Turbo.ServiceDialog.msgsendEmailSuccess", "Mail sent successfully.");
      }).catch(x => {
        this.UI.alert("Turbo.ServiceDialog.sendEmailFail", "Mail failed", "Turbo.ServiceDialog.msgsendEmailFail", "Failed to send mail to the service guy");
      });
    }    
  }

  public async update(status: ServiceRequestStatus, updateText: string = null) {
        this.changeOwner(this.owner);
        var newEstimate = moment();
        var estimateEnabled = true;
        var confirmWebHooks = false;
        switch (status) {
            case ServiceRequestStatus.Invalid:

                newEstimate = this.request.ExpectedResolveDate;
                break;

            case ServiceRequestStatus.Canceled:
                estimateEnabled = false;
                newEstimate = this.now;

                if (this.request.IsInsurance && this.request.ContactEmail && this.request.ContactEmail.length > 0) {
                    var note = await this.UI.prompt("Turbo.ServiceDialog.promptSendEmailHeadline", "Send a message", "Turbo.ServiceDialog.promptSendEmailMsg", "Write a message below explaining why this request will be canceled. The message will be sent to {0}.", null, this.request.ContactEmail);
                    if (note) {
                        this.Api.get("Service/SendRequestFeedback", { requestId: this.request.Id, body: note, feedbackType: RequestFeedbackType.InsuranceRejection });
                    }
                }

                break;

            case ServiceRequestStatus.Completed:
                estimateEnabled = false;
                newEstimate = this.now;
                break;

            case ServiceRequestStatus.Parked:

                newEstimate = this.date(14);
                break;

            case ServiceRequestStatus.ServiceOrdered:
              estimateEnabled = false;
            if (this.Settings.clientSettings.CanOrderService && !this.Settings.isInAny(['Admin', 'BackOffice'], true)) {
                var x = await this.UI.confirm("Turbo.Bookings.OrderServiceDialog.ConfirmRequestService", "Confirm service request", "Turbo.Bookings.OrderServiceDialog.msgConfirmRequestService", "Service orders will be chargeable to customer, and the exact cost will be determined based on the service.Do you wish to continue?");
                if (x) {
                  confirmWebHooks = true;
                }
                else return;
            }

            //This is to handle the case when Admin or backoffice clicks on ServiceOrdered option.
            if (this.Settings.isInAny(['Admin', 'BackOffice'], true)) {
              confirmWebHooks = true;
            }
                if (this.request.ServiceLocationId == 3023)
                    newEstimate = this.date(7);
                else
                    newEstimate = this.date(14);
                break;

            case ServiceRequestStatus.SparePartOrdered:
                newEstimate = this.date(7);


                //if (this.request.IsInsurance) {
                //    var sendTo = 'Annica.Lovgren@brenderupgroup.com';
                //    var note = await this.UI.prompt("Turbo.ServiceDialog.promptSendEmailToHeadline", "Send a message to {0}", "Turbo.ServiceDialog.promptSendEmailSparePart", "Write a message below explaining what is wrong with the trailer and what needs to be ordered. The message will be sent to {0}.", sendTo, sendTo);
                //    if (note) {
                //        await this.Api.get("Service/SendCustomEmail", {
                //            to: this.request.ContactEmail, subject: 'Skicka reservdelar till ' + this.request.RentalObject.Title, body: 'Regnr: ' + this.request.RentalObject.Title + '<br/>' + 'Plats: ' + this.request.ObjectLocation.Name + '( ' + this.request.ObjectLocation.LocationCode + ')' + ', ' + this.request.ObjectLocation.Address + ', ' + this.request.ObjectLocation.City + '<br/>' + this.request.ObjectLocation.Phone ? this.request.ObjectLocation.Phone : '' + '<br/>' + 'Kontaktperson: ' + this.request.ContactFirstName + ' ' + this.request.ContactLastName + '<br/>' + this.request.ContactPhone + '<br/>' + 'Meddelande: ' + note, sender: 'info@brenderuprental.com'
                //        });
                //    }
                //}
                break;

            case ServiceRequestStatus.Expired:
                estimateEnabled = false;
                newEstimate = this.date(365);
                break;

          case ServiceRequestStatus.WaitingForServiceGuy:
            newEstimate = this.date(3)
            break;

            case ServiceRequestStatus.ReturnOrdered:
                estimateEnabled = false;
                newEstimate = this.date(5);
                break;

            case ServiceRequestStatus.TransportOrdered:

                newEstimate = this.date(14);
                break;

            case ServiceRequestStatus.ReportedStolen:

                newEstimate = this.date(21);
            break;

          case ServiceRequestStatus.Incomplete:
            newEstimate = this.date(21);
            break;
        }

        if (updateText) newEstimate = this.date(14);

      var ret = await this.Dialog.open(IssueNoteDialog, { data: { enableEstimate: estimateEnabled, estimatedDate: newEstimate, updateText: updateText, showActivationOption: status == ServiceRequestStatus.Completed, status: status, isInsurance: this.request.IsInsurance } }).afterClosed().toPromise();
        if (!ret) return;
        

        if (status == ServiceRequestStatus.Completed && this.ctrlTags.value && (this.ctrlTags.value.indexOf("Körförbud") >= 0 || this.ctrlTags.value.indexOf("Besiktning") >= 0) && ret.enableObject) {
            this.UI.confirm("Turbo.OneWayAdmin.ServiceDialog.msgConfirmInspection.Headline", "Has the trailer been inspected?", "Turbo.OneWayAdmin.ServiceDialog.msgConfirmInspection.Message", "You are enabling a trailer that needs inspection. Please confirm that the trailer has been inspected within the last few days.").then(x => {
                if (!x) return;

              this.doUpdate(status, ret.newEstimate, ret.notes, ret.enableObject, null, confirmWebHooks);
            });
        } else {
          this.doUpdate(status, ret.newEstimate, ret.notes, ret.enableObject, ret.insuranceTags, confirmWebHooks);
        }
    }

  public setClaimStatus(status: ServiceRequestStatus) {
    var estimate = this.request.ExpectedResolveDate ? moment(this.request.ExpectedResolveDate) : moment();
    this.doUpdate(status, estimate, null, null, null, false);
  }

  private doUpdate(status: ServiceRequestStatus, newEstimate: moment.Moment, notes: string, activateObject: boolean, insuranceTags: string = null, confirmWebHooks: boolean = null) {
    var token = this.beginLoad('Turbo.OneWayAdmin.ServiceDialog.msgUpdatingRequest', 'Updating request', null);
    this.owner = this.request.Owner == null ? this.Settings.getUser().Username : this.request.Owner;


    this.Api.post<RequestDetails>('/Service/UpdateRequest',
      {
        RequestId: this.requestId,
        Description: this.request.Description,
        NewStatus: status,
        Comment: notes,
        ExpectedResolveDate: newEstimate.toISOString(),
        Tags: this.ctrlTags.value,
        IsInsurance: status == ServiceRequestStatus.Canceled && this.request.IsInsurance ? false : this.request.IsInsurance,
        SparePartsCost: this.request.SparePartsCost,
        SparePartsDiscount: this.request.SparePartsDiscount,
        Transport: this.request.TransportCost,
        Labor: this.request.LaborCost,
        SelfRisk: this.request.SelfRisk,
        SalesPrice: this.request.SalesPrice,
        activateObject: activateObject,
        servicePartner: this.selectedServicePartner?.Id,
        InsuranceTags: insuranceTags,
        Owner: this.owner,
        DiarieNumber: this.request.DiarieNumber,
        ConfirmWebHooks: confirmWebHooks        
      }
    ).then(x => {
      this.request = x;
      this.tabControl.selectedIndex = 1;
      this.documentUri = this.sanitizer.bypassSecurityTrustResourceUrl(this.request.ServiceDocument);
      this.endLoad(token);
    });

    if (confirmWebHooks && status == ServiceRequestStatus.ServiceOrdered) {
      this.UI.alert("Turbo.Bookings.OrderServiceDialog.successRequestService", "Service ordered successfully", "Turbo.Bookings.OrderServiceDialog.msgSuccessRequestService", "Your service order has been successfully placed. We will process it soon.", null, null, "/images/Icons/service-success.png");
    }

  }

    public async openFile(file: T4File) {
      console.log(file);
        
      if (file.Filename.toLowerCase().endsWith('jpg') || file.Filename.toLowerCase().endsWith('jpeg') || file.Filename.toLowerCase().endsWith('png')) {
            var ret = await this.Dialog.open(ImageDialog, { data: { imageData: file.Uri } }).afterClosed().toPromise();
        }
        else {
            window.open(file.Uri, "_blank");
        }
    }

  public async terminate() {
    var rows: RentalContractInfo[] = [await this.Api.get<RentalContractInfo>("TurboOrder/GetActiveContractForObject", { objectId: this.request.RentalObjectId })];

    if (rows[0]) {

      await this.Api.post<RequestDetails>('Service/SetLFInvoiceForRequest', null, { requestId: this.request.Id, invoice: true });
      await this.Dialog.open(TerminationDialog, { data: { TerminationRows: rows, Comment: "Försäkringsärende: " + this.request.InsuranceId, Insurance: true, TerminationType: 6, TerminateAt: this.request.IncidentDate } }).afterClosed().toPromise();
    }
    else {
      await this.UI.alert("Turbo.OneWayAdmin.ServiceDialog.msgNoActiveContract.Headline", "No contract found!", "Turbo.OneWayAdmin.ServiceDialog.msgNoActiveContract.Message", "No active contract to be terminated was found for this trailer.");
    }
  }

  public async repurchase() {
    this.request.IsRepurchased = true;
    var ret = await this.Api.post<RequestDetails>('Service/RepurchaseRequest', null, { requestId: this.request.Id })
      .then(x => {
        this.request = x;
        this.tabControl.selectedIndex = 1;
        this.documentUri = this.sanitizer.bypassSecurityTrustResourceUrl(this.request.ServiceDocument);
      });
  }

    public async addCosts() {
        var data = await this.Dialog.open(AddCostsDialog, { data: { spareParts: this.request.SparePartsCost, sparePartsDiscount: this.request.SparePartsDiscount, transport: this.request.TransportCost, labor: this.request.LaborCost, deductible: this.request.SelfRisk, salesPrice: this.request.SalesPrice } }).afterClosed().toPromise();
        if (data) {
            this.request.SparePartsCost = data.spareParts;
            this.request.SparePartsDiscount = data.sparePartsDiscount;
            this.request.TransportCost = data.transport;
            this.request.LaborCost = data.labor;
            this.request.SalesPrice = data.salesPrice;

            //The selfrisk is added from another dialog: look at invoice()
            //this.request.SelfRisk = data.deductible;

            if ((this.request.SparePartsCost - (this.request.SparePartsCost * 0.25) + this.request.TransportCost + this.request.LaborCost - this.request.SelfRisk) > 0) {
                this.request.InvoiceLF = true;
            }

            this.update(-1, "Costs/revenue for the incident have been added to this request.");
        }
        else {
            return;
        }
    }

  public async regenerateServiceDocument() {
    this.isDocumentLoading = true;
    var result = await this.Api.get<string>("/Service/RegenerateServiceDocument", { requestId: this.request.Id, requestNo: this.request.RequestNo, serviceLocationId: this.request.ServiceLocationId });
    this.isDocumentLoading = false;
    if (result) {
      this.documentUri = this.sanitizer.bypassSecurityTrustResourceUrl(result);
      const url = this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, this.documentUri);
      if (url) {
        window.open(url, '_blank');
      }
    }
  }

    public async registerInsurance() {

      if ((!this.imageUploaded || !this.fileUploaded) && !this.backoffice) {
          var continueAnyway = await this.Dialog.open(InsuranceImageInfoDialogComponent, { data: { regNo: this.request.RentalObject.Title, fileUploaded: this.fileUploaded, imageUploaded: this.imageUploaded } }).afterClosed().toPromise();
            if (!continueAnyway) {
                return;
          }
          this.changeOwner(this.owner);
      }

        this.request.IsInsurance = true;
        if (!this.imageUploaded || !this.fileUploaded) {
            this.update(ServiceRequestStatus.Incomplete)
        }
        else {
            this.update(ServiceRequestStatus.New, 'Transformed to insurance case');
        }


    }

  public async convertToClaim() {
    var claimId: string = await this.UI.prompt('Turbo.ServiceDialog.promptConvertToClaimHeadline', 'Convert to claim', 'Turbo.ServiceDialog.promptConvertToClaimMsg', 'Enter the claim id for this case.');
    if (!claimId || claimId.trim().length < 1) return;

    var token = this.beginLoad('Turbo.OneWayAdmin.ServiceDialog.msgConvertingToClaim', 'Converting to claim', null);
    try {
      await this.Api.post<RequestDetails>('/Service/ConvertToClaim', null, { requestId: this.request.Id, claimId: claimId.trim() });
    }
    finally {
      this.endLoad(token);
    }
    await this.loadRequest();
  }

  public async revertClaim() {
    if (!await this.UI.confirm('Turbo.ServiceDialog.headRevertClaim', 'Revert claim?', 'Turbo.ServiceDialog.msgRevertClaim', 'Do you want to revert this claim to a regular case? The claim id will be removed.')) return;

    var token = this.beginLoad('Turbo.OneWayAdmin.ServiceDialog.msgRevertingClaim', 'Reverting claim', null);
    try {
      await this.Api.post<RequestDetails>('/Service/RevertClaim', null, { requestId: this.request.Id });
    }
    finally {
      this.endLoad(token);
    }
    await this.loadRequest();
  }

  public async requestMoreInformation() {
     //var note = await this.UI.prompt("Turbo.ServiceDialog.promptSendEmailHeadline", "Send a message", "Turbo.ServiceDialog.promptSendEmailMoreInformationMsg", "Write a message below explaining what is missing to continue with this case. The message will be sent to the case contact person ({0}).", null, this.request.ContactEmail);
     var note = await this.Dialog.open(ServiceMessageDialogDialog, { data: { dialogTitle: "Request more info", dialogInfoTitle: this.request.RequestNo + " - " + this.request.RentalObject?.Title, templateKey: "T4.ServiceDialog.Email.RequestInfo." } }).afterClosed().toPromise();
        this.changeOwner(this.owner);
        if (note) {
            this.Api.get("Service/SendRequestFeedback", { requestId: this.request.Id, body: note, feedbackType: RequestFeedbackType.MoreInformationNeeded });
            this.update(ServiceRequestStatus.Incomplete, 'Case is incomplete. Email sent to:' + this.request.ContactEmail + '<br/><br/>' + note);
        }
  }


  public async emailLocation() {
    var note = await this.Dialog.open(ServiceMessageDialogDialog, { data: { dialogTitle: "Contact Location", dialogInfoTitle: this.request.RequestNo + " - " + this.request.RentalObject?.Title, templateKey: "T4.ServiceDialog.Email.ContactLocation." } }).afterClosed().toPromise();
    this.changeOwner(this.owner);
    if (note) {
      this.Api.post("Service/SendEmailThroughService", note, { to: this.request.RentalObject?.RentalLocation.Email, subject: "Insurance case - " + this.request.RequestNo + "(" + this.request.RentalObject.Alias + ")" });
      this.update(ServiceRequestStatus.Updated, 'Updated through Contact Location. Email sent to:' + this.request.RentalObject?.RentalLocation.Email + '<br/><br/>' + note);
    }
  }

  public async emailServiceLocation() {
    var note = await this.Dialog.open(ServiceMessageDialogDialog, { data: { dialogTitle: "COntact Service Location", dialogInfoTitle: this.request.RequestNo + " - " + this.request.RentalObject?.Title, templateKey: "T4.ServiceDialog.Email.ContactServiceLocation." } }).afterClosed().toPromise();
    this.changeOwner(this.owner);
    if (note) {
      this.Api.post("Service/SendEmailThroughService", note, { to: this.servicePartner.Email, subject: "Insurance case - " + this.request.RequestNo + "(" + this.request.RentalObject.Alias + ")" });
      this.update(ServiceRequestStatus.Updated, 'Updated through Contact Service Location. Email sent to:' + this.servicePartner.Email + '<br/><br/>' + note);
    }
  }

    public async openContactInfo() {
        var data = await this.Dialog.open(ContactInfoDialog, { data: { contactFirstName: this.request.ContactFirstName, contactLastName: this.request.ContactLastName, contactEmail: this.request.ContactEmail, contactPhone: this.request.ContactPhone } }).afterClosed().toPromise();

        if (data) {
            var updatedFields: string[] = [];
            if (data.contactFirstName && data.contactFirstName !== this.request.ContactFirstName) {
                this.request.ContactFirstName = data.contactFirstName;
                updatedFields.push('First name');
            }
            if (data.contactLastName && data.contactLastName !== this.request.ContactLastName) {
                this.request.ContactLastName = data.contactLastName;
                updatedFields.push('Last name');
            }
            if (data.contactEmail && data.contactEmail !== this.request.ContactEmail) {
                this.request.ContactEmail = data.contactEmail;
                updatedFields.push('Email');
            }
            if (data.contactPhone && data.contactPhone !== this.request.ContactPhone) {
                this.request.ContactPhone = data.contactPhone;
                updatedFields.push('Phone');
            }
            if (updatedFields.length > 0) {
                this.update(ServiceRequestStatus.Updated, 'Updated contact person info: ' + updatedFields.join(', ') + '.');
            }
        }
    }

    public async uploadImages() {
      var data = await this.Dialog.open(UploadImagesDialog, { data: { files: this.files, fileType: 'img', requestId: this.request.ImageIds } }).afterClosed().toPromise();
        this.changeOwner(this.owner);
        if (data && data.files) {
            this.files = data.files;
            if (this.files.find(x => x.Filename.startsWith('img_'))) { this.imageUploaded = true; }
            else { this.imageUploaded = false; }
            this.noOfFiles = this.files.length - 1;
        }
        else {
            this.files = await this.Api.get<any[]>("Service/GetFiles", { requestId: this.request.ImageIds });
            if (this.files.find(x => x.Filename.startsWith('img_'))) { this.imageUploaded = true; }
            else { this.imageUploaded = false; }
            this.noOfFiles = this.files.length - 1;
        }
    }

    public async uploadFiles() {
        var data = await this.Dialog.open(UploadImagesDialog, { data: { files: this.files, fileType: 'doc', requestId: this.request.ImageIds } }).afterClosed().toPromise();
        this.changeOwner(this.owner);
        if (data && data.files) {

            this.files = data.files;
            if (this.files.find(x => x.Filename.startsWith('doc_'))) { this.fileUploaded = true; }
            else { this.fileUploaded = false; }
            this.noOfFiles = this.files.length - 1;
        }
        else {
            this.files = await this.Api.get<any[]>("Service/GetFiles", { requestId: this.request.ImageIds });
            if (this.files.find(x => x.Filename.startsWith('doc_'))) { this.fileUploaded = true; }
            else { this.fileUploaded = false; }
            this.noOfFiles = this.files.length - 1;
        }
  }


  public openPoliceText() {
    const today = new Date().toISOString().split('T')[0];
    this.Dialog.open(PdfServiceDialog, { width: '800px', data: { regNo: this.request.RentalObject?.Title, vehicleNo: this.request.RentalObject, date: today } }).afterClosed().toPromise();
  }
}
